import $ from 'jquery';
import _ from 'lodash';
import cookie from 'jquery.cookie';
import Header from './modules/_header';
import LazyLoad from './modules/_lazyload';
import Swiper from './modules/_braggCarousel';
import Newsletter from './modules/_newsletter';
import Selectric from './modules/_selectric';
import Search from './modules/_search';
import PopUpNewsletter from './modules/_popup-newsletter';
import HeroSlide from './modules/_heroSlider';
import PdpGallery from './modules/_pdp';
import From from './modules/_form';
import Cart from './modules/_cart';
import Modal from './modules/_modal';
import Notify from './modules/_notify';
import Account from './modules/_account';
import SideBar from './modules/_sidebar';
import Animate from './modules/_animation';
import Accordion from './modules/_accordion';

import SlickSlider from './modules/_slickSlider';
import Promise from './modules/_promise';
import AcvCarousel from './modules/_acvCarousel';
import JsFileDownloader from 'js-file-downloader';
import Supplements from './modules/_supplements';

// import './modules/_promise';
import './modules/_cookie';
import './modules/_collections';
import './modules/_hubspot';
import './modules/_video';
import './functions/cart';
import './functions/product';
import './functions/collection';
import './functions/acv';
import './modules/_cursor';
import './modules/_our-history';
// import './modules/_acv-tabs';

window.$ = $;
window._ = _;
window.JsFileDownloader = JsFileDownloader;

var pdp = new PdpGallery();

$(document).ready(function () {
	//enable mobile Navigation
	new Header();

	//enable lazyload
	new LazyLoad();

	//search
	new Search();

	new Newsletter('#newsletter-form');

	new Notify('.stock-form');

	new PopUpNewsletter();

	new HeroSlide();

	pdp.init();

	new From();

	new Cart();

	new Modal();

	new Account();

	new SideBar();

	new Accordion();

	new Promise('#values__list');

	var supplements = new Supplements();
	supplements.init();
	supplements.supplementsTab();
	supplements.InitCounterWatch();
	supplements.showIngredientsOverlay();
	supplements.initKeyIngredientCarousel();
	supplements.initFeedCarousel();

// adding class to animated svg
	$( "figure.benefit__item svg" ).addClass( "benefit__img" );
//

	//quiz select box
	new Selectric('.quiz-select', {
		arrowButtonMarkup:
			'<b class="button"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none" viewBox="0 0 10 7"> <path fill="#ED1C24" d="M5.744 6.172c-.397.442-1.09.442-1.488 0L.436 1.918C-.142 1.274.315.25 1.18.25h7.64c.865 0 1.322 1.024.744 1.668l-3.82 4.254z"/> </svg> </b>',
		maxHeight: 500,
		disableOnMobile: false,
		nativeOnMobile: false,
		customClass: {
			prefix: 'quiz-select',
			camelCase: false,
		},
	});

	//form select box
	new Selectric('.form__control-select', {
		arrowButtonMarkup:
			'<b class="button"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" fill="none" viewBox="0 0 10 7"> <path fill="#ED1C24" d="M5.744 6.172c-.397.442-1.09.442-1.488 0L.436 1.918C-.142 1.274.315.25 1.18.25h7.64c.865 0 1.322 1.024.744 1.668l-3.82 4.254z"/> </svg> </b>',
		maxHeight: 500,
		disableOnMobile: false,
		nativeOnMobile: false,
		customClass: {
			prefix: 'input-select',
			camelCase: false,
		},
	});
	//cookbook select volume box
	new Selectric('.volume__select', {
		arrowButtonMarkup:
			'<b class="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" fill="none" viewBox="0 0 10 7"> <path fill="#ED1C24" d="M5.744 6.172c-.397.442-1.09.442-1.488 0L.436 1.918C-.142 1.274.315.25 1.18.25h7.64c.865 0 1.322 1.024.744 1.668l-3.82 4.254z"/> </svg> </b>',
		maxHeight: 500,
		disableOnMobile: false,
		nativeOnMobile: false,
		customClass: {
			prefix: 'input-select',
			camelCase: false,
		},
	});

	//cook-book carousel
	new Swiper('#cook-book', {
		loop: true,
		slidesPerView: 'auto',
		speed: 600,
		autoplay: {
			delay: 5000,
		},

		breakpoints: {
			320: {
				// slidesPerView: 1.18,
				spaceBetween: 28,
			},

			768: {
				// slidesPerView: 1.739,
				spaceBetween: 18,
			},

			1800: {
				// slidesPerView: 2.739,
				spaceBetween: 20,
			},
		},
	});

	if ($('#menucarousel-3').length) {
		var itemCount = $('#menucarousel-3 .swiper-slide');
		var enableLoop = itemCount >= 3 ? true : false;
		console.log(itemCount + 'menu 3');

		new Swiper('#menucarousel-3', {
			observer: true,
			resizeObserver: true,
			rebuildOnUpdate: true,
			spaceBetween: 0,
			slidesPerView: 'auto',
			speed: 600,
			loop: enableLoop,
			lazy: {
				loadPrevNext: true,
				elementClass: 'swiper-lazy',
			},
			navigation: {
				nextEl: '#menucarousel-3 .swiper-button-next',
				prevEl: '#menucarousel-3 .swiper-button-prev',
			},
			breakpoints: {
				992: {
					slidesPerView: 3,
					// spaceBetween: 1
				},
			},
		});
	}

	if ($('#menucarousel-4').length) {
		var itemCount = $('#menucarousel-4 .swiper-slide').length;
		var enableLoop = itemCount >= 4 ? true : false;
		console.log(itemCount + 'menu 4');

		new Swiper('#menucarousel-4', {
			observer: true,
			resizeObserver: true,
			rebuildOnUpdate: true,
			spaceBetween: 0,
			slidesPerView: 4,
			speed: 600,
			loop: enableLoop,
			lazy: {
				loadPrevNext: true,
				elementClass: 'swiper-lazy',
			},
			navigation: {
				nextEl: '#menucarousel-4 .swiper-button-next',
				prevEl: '#menucarousel-4 .swiper-button-prev',
			},
			breakpoints: {
				992: {
					slidesPerView: 4,
				},
			},
		});
	}

	//Quiz carousel
	window.quizCarousel = function () {
		new Swiper('#quiz-carousel', {
			spaceBetween: 0,
			slidesPerView: 3,
			speed: 600,
			lazy: {
				loadPrevNext: true,
				elementClass: 'quiz__carousel img',
			},
			navigation: {
				nextEl: '#quiz-carousel .swiper-button-next',
				prevEl: '#quiz-carousel .swiper-button-prev',
			},

			breakpoints: {
				// when window width is >= 320px

				320: {
					slidesPerView: 1,
				},

				768: {
					slidesPerView: 3,
				},
			},
		});
	};
	quizCarousel();

	//Review-product carousel
	new Swiper('#review-carousel', {
		spaceBetween: 39,
		slidesPerView: 4.5,
		speed: 600,
		centeredSlides: true,
		loop: true,
		autoplay: {
			delay: 5000,
		},
		navigation: {
			nextEl: '#review-carousel .swiper-button-next',
			prevEl: '#review-carousel .swiper-button-prev',
		},
		breakpoints: {
			// when window width is >= 320px

			320: {
				slidesPerView: 1.249,
				spaceBetween: 16,
			},

			768: {
				slidesPerView: 2.3,
				spaceBetween: 39,
			},
			// when window width is >= 640px
			1280: {
				slidesPerView: 4,
				spaceBetween: 39,
			},
		},
	});

	//Acv carousel
	new AcvCarousel('#acv-carousel', {
		// spaceBetween: 39,
		slidesPerView: 1,
		speed: 600,
		//loop: true,
		Infinite: true,
		centeredSlides: true,
		autoplay: {
			delay: 5000,
		},
		navigation: {
			nextEl: '#acv-carousel .swiper-button-next',
			prevEl: '#acv-carousel .swiper-button-prev',
		},
	});

	//Our story testimonial carousel
	new Swiper('#testimonial-carousel', {
		spaceBetween: 39,
		slidesPerView: 1,
		speed: 600,
		centeredSlides: true,
		loop: true,
		autoplay: {
			delay: 5000,
		},

		breakpoints: {
			// when window width is >= 320px

			320: {
				slidesPerView: 1,
				spaceBetween: 16,
			},

			768: {
				slidesPerView: 1,
				spaceBetween: 39,
			},
			// when window width is >= 640px
			1280: {
				slidesPerView: 1,
				spaceBetween: 39,
			},
		},
		pagination: {
			el: '.story-info__carousel--pag',
			clickable: true,
			renderBullet: function (index, className) {
				return (
					'<span class="' + className + '">' + (index + 1) + '</span>'
				);
			},
		},
	});

	if ($(window).width() < 768) {
		new Swiper('#like-carousel', {
			slidesPerView: 1,
			speed: 600,
			autoplay: {
				delay: 5000,
			},

			navigation: {
				nextEl: '#like-carousel .swiper-button-next',
				prevEl: '#like-carousel .swiper-button-prev',
			},
		});
	}

	// const contactWordSlider = new SlickSlider('#word-slick', {
	//     autoplay: true,
	//     speed: 5000,
	//     // arrows: true,
	//     autoplaySpeed: 0,
	//     //centerMode: true,
	//     arrows: false,
	//     cssEase: 'linear',
	//     slidesToShow: 1,
	//     slidesToScroll: 1,
	//     infinite: true,
	//     loop: true,
	//     variableWidth: true,
	//     pauseOnHover: false,
	// });

	var swiper = new Swiper('#word-slick', {
		spaceBetween: 0,
		centeredSlides: true,
		speed: 6000,
		autoplay: {
			delay: 1,
		},
		loop: true,
		slidesPerView: 'auto',
		allowTouchMove: false,
		disableOnInteraction: true,
		infinite: true,
	});

	var swiper = new Swiper('.marquee', {
		spaceBetween: 0,
		centeredSlides: true,
		speed: 6000,
		autoplay: {
			delay: 1,
		},
		loop: true,
		slidesPerView: 'auto',
		allowTouchMove: false,
		disableOnInteraction: true,
		infinite: true,
	});

	new Swiper('#pdp-tag-marquee', {
		spaceBetween: 0,
		centeredSlides: true,
		speed: 6000,
		autoplay: {
			delay: 1,
		},
		loop: true,
		slidesPerView: 'auto',
		allowTouchMove: false,
		disableOnInteraction: true,
		infinite: true,
	});

	//404 carousel
	new Swiper('#page404', {
		spaceBetween: 0,
		slidesPerView: 3,
		slidesPerColumn: 1,
		speed: 600,
		navigation: {
			nextEl: '#page404 .swiper-button-next',
			prevEl: '#page404 .swiper-button-prev',
		},

		breakpoints: {
			// when window width is >= 320px

			320: {
				slidesPerView: 1,
			},

			768: {
				slidesPerView: 3,
			},
		},
	});

	new Swiper('#suggest-product', {
		spaceBetween: 0,
		speed: 600,
		breakpoints: {
			320: {
				slidesPerView: 2.2,
			},
			992: {
				slidesPerView: 3,
				allowTouchMove: false,
				Draggable: false,
			},
		},
	});

	//ingredient carousel
	// new Swiper('#ingredient', {
	// 	spaceBetween: 54,
	// 	loop: true,
	// 	speed: 600,
	// 	breakpoints: {
	// 		320: {
	// 			slidesPerView: 1.5,
	// 			spaceBetween: 15,
	// 		},
	// 		768: {
	// 			slidesPerView: 3.35,
	// 			spaceBetween: 28,
	// 		},
	// 		1440: {
	// 			slidesPerView: 4,
	// 			spaceBetween: 54,
	// 			navigation: {
	// 				nextEl: '.ingredient__carousel-next',
	// 				prevEl: '.ingredient__carousel-prev',
	// 			},
	// 		},
	// 	},
	// });

	new Swiper('#feeds-marquee', {
		spaceBetween: 0,
		centeredSlides: true,
		speed: 6000,
		autoplay: {
			delay: 1,
		},
		loop: true,
		slidesPerView: 'auto',
		allowTouchMove: false,
		disableOnInteraction: true,
		infinite: true,
	});

	// new Swiper('#feed-carousel', {
	// 	slidesPerView: 3.1,
	// 	spaceBetween: 0,
	// 	speed: 500,
	// 	autoplay: {
	// 		delay: 3000,
	// 		disableOnInteraction: true,
	// 	},
	// 	loop: true,
	// 	infinite: true,
	// 	breakpoints: {
	// 		320: {
	// 			slidesPerView: 1.276,
	// 		},
	// 		768: {
	// 			slidesPerView: 3.07,
	// 		},
	// 	},
	// });

	//cookie
	if (!$.cookie('cookie')) {
		setTimeout(function () {
			$('#cookie').fadeIn();
		}, 1000);
	}

	//hide cookie bar
	$('.cookie__btn').on('click', function (e) {
		e.preventDefault();
		$.cookie('cookie', true);
		$('#cookie').fadeOut();
	});

	//review form show
	$('.js-form-button').on('click', function () {
		$(this).parents('.tab__content-item').find('.ratings').hide();
		$(this).parents('.tab__content-item').find('.tab__form').show();
	});

	//smooth scroll anchor click
	$('a.scrollLink').click(function (event) {
		event.preventDefault();
		$('html, body').animate(
			{
				scrollTop: $($(this).attr('href')).offset().top,
			},
			500
		);
	});

	//Sticky blog sidebar on scroll
	let stickyElement = $('.stickthis');
	let getHeaderHeight = $('.header__inner').outerHeight();
	let sidebar = $('.blog__sidebar ');

	if (stickyElement.length) {
		let stickySidebarToTop = stickyElement.offset().top - getHeaderHeight;
		$(window).on('scroll resize', function () {
			let windowToTop = $(window).scrollTop();
			if (windowToTop >= stickySidebarToTop) {
				$('.stickthis').addClass('fixed');

				if ($(window).outerWidth() <= 1200) {
					$(sidebar).outerHeight($(stickyElement).outerHeight());
				}
			} else {
				$('.stickthis').removeClass('fixed');
				if ($(window).outerWidth() >= 1200) {
					$(sidebar).outerHeight('100%');
				}
			}
		});
	}

	//slide section
	$(document).on('click', '.scrollTo', (e) => {
		e.preventDefault();
		let to = $(e.currentTarget).attr('data-scroll'),
			getHeaderHeight = $('.header__inner').outerHeight();
		$('html, body').animate(
			{
				scrollTop: $(`#${to}`).offset().top - getHeaderHeight + 1,
			},
			500
		);
	});

	// Read Wellness Carousel
	window.blogSidebarCarousel = function () {
		new Swiper('#blog__sidebar_carousel', {
			observeParents: true,
			resizeObserver: true,
			rebuildOnUpdate: true,
			spaceBetween: 0,
			slidesPerView: 1,
			loop: true,
			autoplay: {
				delay: 5000,
			},
			navigation: {
				nextEl: '#blog__sidebar_carousel .swiper-button-prev',
				prevEl: '#blog__sidebar_carousel .swiper-button-next',
			},
		});
	};
	blogSidebarCarousel();

	// Read content Carousel
	new Swiper('#blog__content_carousel', {
		observer: true,
		resizeObserver: true,
		rebuildOnUpdate: true,
		spaceBetween: 0,
		slidesPerView: 3,
		autoplay: {
			delay: 5000,
		},
		loop: true,
		navigation: {
			nextEl: '#blog__content_carousel .swiper-button-prev',
			prevEl: '#blog__content_carousel .swiper-button-next',
		},

		breakpoints: {
			// when window width is >= 320px

			320: {
				slidesPerView: 1,
			},
			576: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 3,
			},
		},
	});

	$('.account__body .form')
		.find('[type="submit"]')
		.parent()
		.prev()
		.addClass('form__row--before');

	$(document.body).on('click', '.marquee--recipe', (e) => {
		e.stopPropagation();
		$('#popup-newsletter').fadeIn();
	});

	$(document.body).on('click', '.marquee--recipe', (e) => {
		e.stopPropagation();
		$('#popup-newsletter').fadeIn();
	});

	function halfCircle() {
		var parentWidth = $('.contact__header').outerWidth(),
			circleParent = $('.contact__header--circle'),
			circle = $('.circle_graphics');

		if ($(window).width() >= 768) {
			$(circleParent).css({
				height: parentWidth / 2 + 'px',
			});

			$(circle).css({
				width: parentWidth + 'px',
				height: parentWidth + 'px',
			});
		}
	}

	halfCircle();

	$(window).on('resize', () => {
		halfCircle();
	});

	$('.pdp__pack-item').on('click', (e) => {
		$('.pdp__pack-item').removeClass('pdp__pack-item--active');
		$(e.currentTarget).addClass('pdp__pack-item--active');
	});

	//cookbook mobile navigation popup
	$('#book__mobmenu_cta').on('click', (e) => {
		e.preventDefault();
		$('#book__mobmenu_cta').toggleClass('active');
		$('#book__mobmenu_modal').toggleClass('active');
	});

	//cookbook mobile navigation submenu accordion
	let cookbookMobAccordion = document.querySelector('.book__mobmenu_list');

	if (cookbookMobAccordion) {
		let cookbookMobAccordionItems = cookbookMobAccordion.querySelectorAll(
			'.book__mobmenu_item'
		);
		cookbookMobAccordionItems.forEach((item) => {
			let title = item.querySelector('.book__mobmenu_title');

			title.addEventListener('click', (e) => {
				const opened_item =
					cookbookMobAccordion.querySelector('.is-open');

				// Toggle current item
				toggle_item(item);

				// Close earlier opened item if exists
				if (opened_item && opened_item !== item) {
					toggle_item(opened_item);
				}
			});
		});
	}

	//cookbook mobile nav accordion toggle
	const toggle_item = (item) => {
		const cookbookMobCTA = $('#book__mobmenu_cta');
		const itemTitleValue = item.querySelector(
			'.book__mobmenu_title'
		).innerHTML;

		if (item.classList.contains('is-open')) {
			item.classList.remove('is-open');
		} else {
			item.classList.add('is-open');
			if (item.classList.contains('is-open')) {
				cookbookMobCTA.text(itemTitleValue);
			}
		}
	};
	//acv applde tabs
	if ($('.acv-tabs')) {
		$('.acv-tabs .btn--acv').on('click', function () {
			console.log('click');
			let thisParent = $(this).closest('.acv-tabs');
			let thisTarget = $(this).attr('data-target');
			let targetTab = $(thisTarget);
			thisParent.find('.acv-tabs__item').removeClass('tab-active');
			targetTab.addClass('tab-active');
			thisParent.find('.btn--acv').removeClass('active');
			$(this).addClass('active');
		});
	}

	// Setup YOTPO
	const APP_KEY_QA = 'KHiZYtXTMITuH8nzBTye6fID0psLRF7Uhirf3QKp';
	const APP_KEY_PROD = 'Euw8a3S7ftWrtOjbEfxJPICTD7RaUIb4kTGzTCmb';
	const YOTPO_REVIEW_URL = `https://api.yotpo.com/v1/widget`;
	const CREATE_QUESTION_URL = `https://api.yotpo.com/questions/send_confirmation_mail`;
	const APP_KEY = window.Shopify.shop.includes('bragg-dev.myshopify.com')
		? APP_KEY_PROD
		: APP_KEY_QA;
	let page = 1;
	let sort = 'votes_up';
	let sort_direction = 'desc';

	function fetchReviews(e) {
		var sort_clicked = false;
		if (e) {
			e.preventDefault();
			if ($(this).attr('data-sort')) {
				sort = $(this).attr('data-sort');
				sort_direction = $(this).attr('data-order');
				page = 1;
				sort_clicked = true;
				$(".selected").text($(this).text());
			}
		}
		fetch(
			`${YOTPO_REVIEW_URL}/${APP_KEY}/products/${product.id}/reviews.json?page=${page}&sort=${sort}&direction=${sort_direction}`,
			{
				method: 'GET',
			}
		)
			.then(function (response) {
				if (!response.ok) return;

				response.json().then(function (res) {
					const { pagination } = res.response;
					page = pagination.page + 1;
					if (
						pagination.page * pagination.per_page >=
						pagination.total
					) {
						$('#rating .load-more').hide();
					}

					if (sort_clicked) {
						$('.reviews-container .tab-card').remove();
					}
					initReviewData(res.response);
				});
				// const res = await response.json();
				// const {pagination} = res.response;
				// page = pagination.page + 1;
				// if (pagination.page * pagination.per_page >= pagination.total) {
				//     $("#rating .load-more").hide();
				// }
				// initReviewData(res.response);
			})
			.catch((err) => console.error(err));

		function initReviewData(data) {
			// Append reviews
			console.log();
			if (data.reviews.length > 0) {
				$('.custom-yotpo-sorting').show();
			}
			
			data.reviews.forEach((item) => {
				const reviewEl = $(`
                <div class="tab-card">
                    <div class="tab-card__inner">
                        <div class="d-xs-flex align-items-center justify-content-between tab-card__user">
                            <p class="tab-card__user-name">${item.user.display_name}</p>
                            <div class="rating tab-card__user-rating" title="${item.score}">
                                <div class="rating__back"></div>
                            </div>
                        </div>
                        <h3 class="subtitle--2 tab-card__subtitle" data-itemId=${item.id}>${item.title}</h3>
                        <p class="d-xs-block d-md-inline-block tab-card__text">${item.content}</p>
                        <div class="custom-vote vote yotpo">
                        	<span class="up-vote yotpo-icon yotpo-icon-thumbs-up">${item.votes_up}</span>
                        	<span class="down-vote yotpo-icon yotpo-icon-thumbs-down">${item.votes_down}</span>
                        </div>
                    </div>
                </div>
            `);
				for (let i = 1; i <= item.score; i++) {
					reviewEl
						.find('.rating__back')
						.append('<i class="icon-star"></i>');
				}
				$('.reviews-container').append(reviewEl);
				reviewEl.find(".custom-vote .up-vote")
					.on('click', function() {
						var __this = $(this);
						var iId = __this.closest(".tab-card__inner").find("h3").attr("data-itemId");
						var currentLikes = __this.text();
						currentLikes = parseInt(currentLikes);
						console.log(iId);
						
					$.ajax({
					  url: `https://api.yotpo.com/reviews/${iId}/vote/up`,
					  type: "POST",
					  dataType: 'json',
					  success: function(res) {
					  	console.log(res);
							__this.text(currentLikes+1);
						},
					  error: function(err) {
					  	console.log(err);
					  } 	
					});
				});

				reviewEl.find(".custom-vote .down-vote")
					.on('click', function() {
						var __this = $(this);
						var iId = __this.closest(".tab-card__inner").find("h3").attr("data-itemId");
						var currentLikes = __this.text();
						currentLikes = parseInt(currentLikes);
						console.log(iId);
						
					$.ajax({
					  url: `https://api.yotpo.com/reviews/${iId}/vote/down`,
					  type: "POST",
					  dataType: 'json',
					  success: function(res) {
					  	console.log(res);
							__this.text(currentLikes+1);
						},
					  error: function(err) {
					  	console.log(err);
					  } 	
					});
				});	
				
			});
			// Append total review
			const container = $('.rating__star');
			const topContainer = $('.rating');
			const rating_widths = [0,  8.25, 17.75, 27.25, 36.75, 46.25, 55.75, 65.25, 74.75, 84.25, 100];
			if (!data.bottomline.total_review) {
				container.hide();
			} else {
				container
					.find('.rating__text')
					.text(
						`Based on ${data.bottomline.total_review} Review${
							data.bottomline.total_review > 1 ? 's' : ''
						}`
					);
				container
					.find('.rating-wrapper')
					.css('width', rating_widths[Math.round(data.bottomline.average_score * 2.0)] + '%');

				topContainer.show();
				topContainer
					.find('.rating-wrapper')
					.css('width', rating_widths[Math.round(data.bottomline.average_score * 2.0)] + '%');
				topContainer
					.find('span')
					.text(`(${data.bottomline.total_review})`);
			}
		}
	}
	var pageFAQ = 1;
	function fetchFAQ() {
		fetch(
			`https://api.yotpo.com/products/${APP_KEY}/${product.id}/questions?page=${pageFAQ}`,
			{
				method: 'GET',
			}
		)
			.then(function (response) {
				if (!response.ok) return;
				response.json().then(function (res) {
					initFAQData(res.response);
				});
				// const res = await response.json();
				// initFAQData(res.response);
			})
			.catch((err) => console.error(err));
		// initFAQData(require('./test.json').response)
		function initFAQData(data) {
			var dataPage = parseInt(data.page);
			if ( dataPage * data.per_page >= data.total_questions ) {
				console.log('calling');
				$('.review-faq-form__loadmore').hide();
			}
			// Append FAQ
			data.questions.forEach((item) => {
				const answer = item.sorted_public_answers[0];
				const faqEl = $(`
                    <div class="tab-card tab-card--faq">
                        <div class="tab-card__inner">
                            <h6 class=" tab-card__subtitle">${item.content}</h6>
                            <p class="d-xs-block d-md-inline-block tab-card__text" style="white-space: pre-line;">${answer.content}</p>
                            <div class="d-md-grid grid-auto tab-card__footer">
                                <p>Was this question helpful to you?</p>
                                <div class="d-xs-flex question">
                                    <a class="question__cta" data-id="${answer.id}" data-type="up" href="#">YES <sup>${answer.votes_up}</sup></a>
                                    <a class="question__cta" data-id="${answer.id}" data-type="down" href="#">NO <sup>${answer.votes_down}</sup></a>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
				$('.faq-container').append(faqEl);
			});
		}
	}
	
	$(".review-faq-form__loadmore").on("click", function (e) {
        e.preventDefault();
        pageFAQ++;
        fetchFAQ();
    });

	$('body').on('click', '.question__cta', function (e) {
		e.preventDefault();
		const id = $(this).data('id');
		const type = $(this).data('type');
		const value = $(this).find('sup').html();
		$.get(`https://api.yotpo.com/answers/${id}/vote/${type}`)
			.then((res) => {
				$(this)
					.find('sup')
					.html(parseInt(value) + 1);
			})
			.catch((err) => {
				console.log(err);
			});
	});

	$('.range__btn').on('click', function (e) {
		e.preventDefault();
		let range = $(this).parent().find('input');
		let current_value = parseInt(range.val());
		let classname = $(this).attr('class');
		let min = range.attr('min');
		let max = range.attr('max');
		let step = parseInt(range.attr('step'));
		if (classname === 'range__btn range__btn--min') {
			if (current_value <= min) return false;
			else {
				range.val(current_value - step);
			}
		} else {
			if (current_value >= max) return false;
			else {
				range.val(current_value + step);
			}
		}
	});

	$('#review-form').on('submit', function (e) {
		const form = $(e.target);
		e.preventDefault();
		fetch(`${YOTPO_REVIEW_URL}/reviews`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				appkey: APP_KEY,
				sku: product.id,
				product_title: product.title,
				product_url: location.href,
				display_name: form.find('#review-name').val(),
				email: form.find('#review-email').val(),
				review_content: form.find('#review-review').val(),
				review_title: form.find('#review-title').val(),
				review_score: form.find('[name="rate"]:checked').val(),
			}),
		})
			.then(function (response) {
				if (response.ok) {
					form.hide();
					$('#review-thank-you').show();
					form.trigger('reset');
				} else {
					response.json().then(function (res) {
						form.find('.error').html(res.status.message);
					});
					// const {status} = await response.json()
					// form.find('.error').html(status.message)
				}
			})
			.catch(function (err) {
				err.json().then(function (res) {
					form.find('.error').html(res.res.status.message);
				});
				// const {res} = await err.json()
				// form.find('.error').html(res.message)
			});
	});

	$('#faq-form').on('submit', function (e) {
		const form = $(e.target);
		e.preventDefault();

		const body = {
			review_content: form.find('#question').val(),
			display_name: form.find('#ask-name').val(),
			email: form.find('#ask-email').val(),
			appkey: APP_KEY,
			sku: product.id,
			product_title: product.title,
			product_url: location.href,
		};
		$.post(CREATE_QUESTION_URL, body)
			.then(function (res) {
				form.hide();
				$('#faq-thank-you').show();
				form.trigger('reset');
			})
			.catch(function (err) {
				if (err.responseJSON && err.responseJSON.status) {
					form.find('.error').html(err.responseJSON.status.message);
				}
			});
	});

	if (window.product) {
		fetchReviews();
		fetchFAQ();

		$('#rating .load-more').on('click', fetchReviews);
		$('#rating .sorting .list-category').on('click', fetchReviews);
		
		$('#review-thank-you-close').on('click', function () {
			$('#review-thank-you').hide();
			$('#review-form').show();
		});

		$('#faq-thank-you-close').on('click', function () {
			$('#faq-thank-you').hide();
			$('#faq-form').show();
		});

		const item = document.getElementById('rating');
		let observer = new IntersectionObserver(
			([entry]) => {
				if (entry.intersectionRatio > 0) {
					console.log(item);
					$('.tab__content-item:first-of-type').show();
					observer.unobserve(entry.target);
				}
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: 0.5,
			}
		);
		observer.observe(item);
	}

	if (meta.page.pageType === 'home') {
		// Home page animation
		const setangle = (from, to, duration = 1000, callback, endCallback) => {
			const timeLineInner = document.querySelector('.timeline__frame');
			const timeLineInnerRect = timeLineInner.getBoundingClientRect();
			const star = $('.timeline__star');
			const rectCircle = document
				.getElementById('timeline-svg-circle')
				.getBoundingClientRect(); // Fix

			const BOTTOM_OFFSET =
				timeLineInnerRect.y +
				timeLineInnerRect.height -
				(rectCircle.y + rectCircle.height);

			const CIRCLE_BOX_WIDTH = rectCircle.width;
			const CIRCLE_BOX_HEIGHT = rectCircle.height;
			const X_OFFSET = (timeLineInnerRect.width - CIRCLE_BOX_WIDTH) / 2;
			const Y_OFFSET =
				timeLineInnerRect.height - CIRCLE_BOX_HEIGHT - BOTTOM_OFFSET;
			const H = CIRCLE_BOX_HEIGHT;
			const C = CIRCLE_BOX_WIDTH;
			const R = H / 2 + C ** 2 / (8 * H);
			const center = {
				x: C / 2 + X_OFFSET,
				y: R + Y_OFFSET,
			};

			let newAngle = from;
			const animate = () => {
				setTimeout(() => {
					const angleInRad = newAngle * (Math.PI / 180);
					const x = Math.cos(angleInRad) * R;
					const y = Math.sin(angleInRad) * R;
					star.css('left', `${center.x + x}px`);
					star.css('top', `${center.y + y}px`);
					star.attr('data-angle', newAngle);
					if (callback && Math.abs(newAngle - to) <= 20) {
						callback();
					}
					if (to < from) {
						newAngle -= 0.2;
						if (newAngle > to) {
							animate();
						} else {
							if (endCallback) endCallback();
						}
					} else {
						newAngle += 0.2;

						if (newAngle < to) {
							animate();
						} else {
							if (endCallback) endCallback();
						}
					}
				}, 0);
			};
			animate();
		};
		setangle(225, 225, 0);
		let inProgress = false;
		const setActiveTimeLine = (step) => {
			if (inProgress) {
				return;
			}
			const currentAngle = $('.timeline__star').attr('data-angle');

			const callback = () => {
				const container = $('.timeline__inner');
				container.removeClass(`active-timeline-1`);
				container.removeClass(`active-timeline-2`);
				container.removeClass(`active-timeline-3`);
				container.addClass(`active-timeline-${step}`);
				container.attr('data-active-timeline', step);
				// inProgress = false
			};
			const endCallback = () => {
				inProgress = false;
			};
			if (window.innerWidth < 768) {
				callback();
			} else {
				inProgress = true;
				if (step === 1) {
					setangle(
						parseInt(currentAngle),
						225,
						1000,
						callback,
						endCallback
					);
				} else if (step === 2) {
					setangle(
						parseInt(currentAngle),
						270,
						1000,
						callback,
						endCallback
					);
				} else if (step === 3) {
					setangle(
						parseInt(currentAngle),
						315,
						1000,
						callback,
						endCallback
					);
				}
			}
		};

		$('[data-timeline-step]').on('click', (e) => {
			setActiveTimeLine(parseInt($(e.target).attr('data-timeline-step')));
		});

		let isAnimated = false;
		$('.timeline__frame').on('mouseover', () => {
			if (isAnimated) {
				return;
			}
			isAnimated = true;
			setActiveTimeLine(2);
			setTimeout(() => {
				setActiveTimeLine(3);
			}, 1500);
		});

		const autoAnimate = () => {
			if (window.innerWidth < 768) {
				setTimeout(() => {
					setActiveTimeLine(2);
				}, 2000);
				setTimeout(() => {
					setActiveTimeLine(3);
				}, 4000);
				setTimeout(() => {
					setActiveTimeLine(1);
					autoAnimate();
				}, 6000);
			}
			if (window.innerWidth < 1024 && window.innerWidth >= 768) {
				setTimeout(() => {
					setActiveTimeLine(2);
				}, 1500);
				setTimeout(() => {
					setActiveTimeLine(3);
				}, 4500);
			}
		};

		let observer = new IntersectionObserver(
			([entry]) => {
				if (entry.intersectionRatio > 0) {
					autoAnimate();
					observer.unobserve(entry.target);
				}
			},
			{
				root: null,
				rootMargin: '0px',
				threshold: 0.3,
			}
		);
		observer.observe(document.querySelector('.timeline__frame'));

		window.onresize = () => {
			const step = parseInt(
				$('.timeline__inner').attr('data-active-timeline')
			);
			if (step) {
				setActiveTimeLine(step);
			}
		};
	}

	const followSection = document.getElementById('follow-slick');
	if (followSection) {
		let observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (!mutation.addedNodes) return;
				const images = $(
					'#insta-feed .instafeed-container img.js-lazy-image'
				);

				if (images.length) {
					$('#insta-feed img').each((index, item) => {
						$('#follow-slick').append(
							`<img class="follow__slider-item" alt="${$(
								item
							).attr('alt')}" src="${$(item).data('src')}" />`
						);
					});

					const contactSlider = new SlickSlider('#follow-slick', {
						autoplay: true,
						speed: 10000,
						autoplaySpeed: 0,
						arrows: false,
						cssEase: 'linear',
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
						variableWidth: true,
						pauseOnHover: false,
						responsive: [
							{
								breakpoint: 1024,
								settings: 'unslick',
							},
						],
					});
					observer.disconnect();
				}
			});
		});

		observer.observe(document.getElementById('insta-feed'), {
			childList: true,
		});
	}
});

$(window).on('load', () => {
	new Animate('.tab-card', {
		animateClassName: 'tab-card--visible',
		offset: 0,
	});

	pdp.stickyAddToCart();
});
